<span class="ellipsis" [matTooltip]="name">{{ name }}</span>
